module.exports = __webpack_public_path__ + "static/img/ico-social.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ico-social.png
// module id = 562
// module chunks = 0